export const calcOrderShipperTotal = (order) => {
    return (order?.shipper_rate || 0) + (order?.middle_mile_shipper_rate || 0) + (order?.warehouse_shipper_rate || 0);
};

const ROLE_ID_FIELDS = {
    shipper: 'shipper_id',
    carrier: 'carrier_id',
    middle_mile_carrier: 'middle_mile_carrier_id',
    contractor: 'contractor_id',
};

// Contractor outranks carrier to agree with the audit modal's carrierPerspective, which bills the
// subcontractor when one client holds both legs.
const ROLE_PRECEDENCE = ['shipper', 'contractor', 'carrier', 'middle_mile_carrier'];

export const calcOrderRole = (order, clientIds) => {
    if (order?.oms) return 'internal';

    // Array, not any iterable — a bare id string would substring-match instead of failing.
    const ids = Array.isArray(clientIds) ? clientIds : [];

    return ROLE_PRECEDENCE.find((role) => ids.includes(order?.[ROLE_ID_FIELDS[role]])) || null;
};

const ROLE_RATE_FIELDS = {
    internal: 'order_revenue',
    carrier: 'carrier_rate',
    middle_mile_carrier: 'middle_mile_carrier_rate',
    contractor: 'contractor_rate',
};

export const calcOrderPricing = (order, clientIds) => {
    const role = calcOrderRole(order, clientIds);
    if (role === 'shipper') return calcOrderShipperTotal(order);

    return order?.[ROLE_RATE_FIELDS[role]] || 0;
};

const ROLE_LABELS = {
    internal: 'Internal',
    shipper: 'Shipper',
    carrier: 'Carrier',
    middle_mile_carrier: 'Middle Mile Carrier',
    contractor: 'Contractor',
};

export const calcOrderOwner = (order, clientIds) => ROLE_LABELS[calcOrderRole(order, clientIds)];

const ROLE_BREAKDOWNS = {
    internal: 'internalBreakdown',
    shipper: 'shipperBreakdown',
    carrier: 'carrierBreakdown',
    middle_mile_carrier: 'mmCarrierBreakdown',
    contractor: 'contractorBreakdown',
};

// Middle-mile and warehouse carriers stay on the carrier columns by design: middle_mile_carrier_rate is
// set on 692 of 13,136 middle-mile orders, so resolving that leg here would blank most of the column.
const DISPLAY_ROLES = ['internal', 'shipper', 'contractor'];

const displayRole = (order, clientIds) => {
    const role = calcOrderRole(order, clientIds);

    return DISPLAY_ROLES.includes(role) ? role : 'carrier';
};

export const calcOrderBreakdown = (order, clientIds) =>
    order?.price_breakdown?.[ROLE_BREAKDOWNS[displayRole(order, clientIds)]];

export const calcOrderRateOwed = (order, clientIds) => {
    const role = displayRole(order, clientIds);
    if (role === 'shipper') return order?.shipper_rate;

    return order?.[ROLE_RATE_FIELDS[role]];
};
